var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    typography = _ref.typography;
  return {
    barFillColor: colors.contrasts.blue4570,
    barStarFillColor: colors.contrasts.orange4570,
    barLabelColor: colors.contrasts.grey125125,
    barLabelFontFamily: typography.fontFamily,
    barLabelFontSize: typography.fontSizeSmall,
    xAxisColor: colors.contrasts.grey125125
  };
};
export default generateComponentTheme;